import { Document } from '@react-pdf/renderer';
import StartPage from './components/StartPage';
import InfoPage from './components/InfoPage';
import TablePage from './components/TablePage';
import { Font } from '@react-pdf/renderer';
import MarketsPage from '@/components/pdf/components/MarketsPage';
import ChivoRegular from '@/assets/fonts/Chivo-Regular.ttf';
import ChivoSemiBold from '@/assets/fonts/Chivo-SemiBold.ttf';
import ChivoLight from '@/assets/fonts/Chivo-Light.ttf';
import ChivoBold from '@/assets/fonts/Chivo-Bold.ttf';
import PriceDevelopmentPage from '@/components/pdf/components/PriceDevelopmentPage';
import { ProjectType, SoldRefDataType, MarkerObjectType, CoordinatesType, ReportSettingsType } from '@/types/dataTypes';
import { UserType } from '@/types/apiTypes';
import { MarketDataState } from '@/context/FilterContext';
// Register font
Font.register({ family: 'Chivo', weight: 200, src: ChivoLight });
Font.register({ family: 'Chivo', weight: 400, src: ChivoRegular });
Font.register({ family: 'Chivo', weight: 500, src: ChivoSemiBold });
Font.register({ family: 'Chivo', weight: 600, src: ChivoBold });

interface PdfProps {
  hideClientData: boolean;
  project: ProjectType;
  reportSettings: ReportSettingsType;
  marketData: MarketDataState;
  refData: SoldRefDataType;
  userData: UserType | null | undefined;
  selectedReportItems: { [key: string]: boolean } | null;
  soldMarkerObjects: MarkerObjectType[] | null;
  currentCoordinates: CoordinatesType;
  priceImage: string | null;
  marketImage: string | null;
  soldCalculations: any;
  adsCalculations: any;
}

const Pdf = (props: PdfProps) => {
  const sortedStorageItem = localStorage.getItem('table-sorting') || '';
  const sortingAds = sortedStorageItem ? JSON.parse(sortedStorageItem) : null;
  return (
    <Document>
      <StartPage projectName={props.project.name} customer={props.userData?.customer} />
      <InfoPage
        project={props.project}
        reportSettings={props.reportSettings}
        refData={props.refData}
        soldMarkerObjects={props.soldMarkerObjects}
        currentCoordinates={props.currentCoordinates}
        hideClientData={props.hideClientData}
        customer={props.userData?.customer}
        username={props.userData?.email}
      />
      {props.project.soldTableData && props.selectedReportItems?.sold && (
        <TablePage
          project={props.project}
          table={'sold'}
          sorting={props.project.sale_references_sort}
          hideClientData={props.hideClientData}
          customer={props.userData?.customer}
          username={props.userData?.email}
          soldCalculations={props.soldCalculations}
        />
      )}
      {props.project.adsTableData && props.selectedReportItems?.ads && (
        <TablePage
          project={props.project}
          table={'ads'}
          sorting={sortingAds?.length ? sortingAds[0] : null}
          hideClientData={props.hideClientData}
          customer={props.userData?.customer}
          username={props.userData?.email}
          adsCalculations={props.adsCalculations}
        />
      )}
      {props.project.marketAds && props.selectedReportItems?.market && (
        <MarketsPage
          projectName={props.project.name}
          marketData={props.marketData}
          data={props.project.marketAds}
          hideClientData={props.hideClientData}
          username={props.userData?.email}
          marketImage={props.marketImage}
          customer={props.userData?.customer}
        />
      )}
      {props.project.indexData &&
        props.selectedReportItems?.priceDevelopment && (
          <PriceDevelopmentPage
            projectName={props.project.name}
            data={props.project.indexData}
            project={props.project}
            hideClientData={props.hideClientData}
            username={props.userData?.email}
            priceImg={props.priceImage}
            customer={props.userData?.customer}
          />
        )}
    </Document>
  );
};
export default Pdf;
